var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            title: _vm.$t("GlobalSetObj.tips"),
            visible: _vm.tipDialog,
            top: "10vh",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipDialog = $event
            },
          },
        },
        [
          _vm.isShowConfirm
            ? _c("div", { staticStyle: { "font-size": "16px" } }, [
                _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("GlobalSetObj.Selecionadas")) + ": "),
                  ]),
                  _c("span", { staticStyle: { color: "#00A551" } }, [
                    _vm._v(" " + _vm._s(_vm.selectedData.length)),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "15px",
                      "font-weight": "bold",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("vehicle.confirmBatchFinalApproval")) +
                        " "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.isShowResult
            ? _c("div", { staticStyle: { "font-size": "14px" } }, [
                _c(
                  "div",
                  {
                    staticClass: "flx-between",
                    staticStyle: { "margin-bottom": "15px" },
                  },
                  [
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("operationCenter.TotalQuantity")) +
                          "："
                      ),
                      _c("span", { staticStyle: { color: "#00A551" } }, [
                        _vm._v(_vm._s(_vm.auditResult.totalCount)),
                      ]),
                    ]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("operationCenter.TheOperationSucceeded")
                          ) +
                          "：" +
                          _vm._s(_vm.auditResult.successCount) +
                          " "
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("mdfeTranslate.OperationFailed")) +
                          "："
                      ),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.auditResult.failCount)),
                      ]),
                    ]),
                  ]
                ),
                _vm.auditResult.failCount > 0
                  ? _c("div", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("GlobalSetObj.ReasonForFailure")) +
                          " : "
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "15px",
                      "line-height": "25px",
                      color: "#00A551",
                      "letter-spacing": "1px",
                    },
                  },
                  _vm._l(
                    _vm.auditResult.failReasonList,
                    function (reason, index) {
                      return _c("div", { key: index }, [
                        _vm._v(" " + _vm._s(reason) + " "),
                      ])
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.isShowResult
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmFinalAudit(1)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.close")) + " ")]
                  )
                : [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmFinalAudit(1)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("GlobalSetObj.cancel")) + " "
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmFinalAudit(2)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("GlobalSetObj.confirm")) + " "
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }